export const isProduction = process?.env?.NODE_ENV === 'production';
const currentHost = location.hostname || 'localhost';
export const COTREAT_API_SERVER_HOST =
  process.env.COTREAT_API_SERVER_HOST || `http://${currentHost}:8081`;
export const COTREAT_IMAGE_ANALYSIS_SERVICE_HOST =
  process.env.COTREAT_IMAGE_ANALYSIS_SERVICE_HOST || `http://${currentHost}:8040`;
export const COTREAT_JS_SDK_HOST = process.env.COTREAT_JS_SDK_HOST || `http://${currentHost}:8005`;
export const COTREAT_AI_SERVICE_HOST =
  process.env.COTREAT_AI_SERVICE_HOST || `http://${currentHost}:8060`;
